export type StepperStep = {
  label: string
}

export type StepperStepStatus = 'inactive' | 'active' | 'completed'

export type StepperConnectorTone = 'completed' | 'active' | 'inactive'

export type StepperOrientation = 'horizontal' | 'vertical'

export type StepperPreviewStep = 1 | 2 | 3 | 4

export const STEPPER_PREVIEW_STEPS: StepperPreviewStep[] = [1, 2, 3, 4]

export const STEPPER_PREVIEW_STEP_LABELS: Record<StepperPreviewStep, string> = {
  1: 'Step 1',
  2: 'Step 2',
  3: 'Step 3',
  4: 'Step 4',
}

export const STEPPER_DEMO_STEPS: StepperStep[] = [
  { label: 'Text' },
  { label: 'Text' },
  { label: 'Text' },
  { label: 'Text' },
]

export const STEPPER_LIVE_STEPS: StepperStep[] = [
  { label: 'Patient info' },
  { label: 'Insurance' },
  { label: 'Review' },
  { label: 'Confirm' },
]

export type StepperProps = {
  steps?: StepperStep[] | string[]
  /** Zero-based index of the active step. */
  currentStep?: number
  orientation?: StepperOrientation
  className?: string
  /** Dark surface styling. Dark keeps the same step tones. */
  darkMode?: boolean
  /** Static active step for the design-system showcase only (1-based). */
  previewStep?: StepperPreviewStep
  onStepClick?: (stepIndex: number) => void
}

export const normalizeStepperSteps = (
  steps: StepperStep[] | string[],
): StepperStep[] =>
  steps.map((step) => (typeof step === 'string' ? { label: step } : step))

export const getStepperStepStatus = (
  stepIndex: number,
  currentStep: number,
): StepperStepStatus => {
  if (stepIndex < currentStep) {
    return 'completed'
  }

  if (stepIndex === currentStep) {
    return 'active'
  }

  return 'inactive'
}

export const getStepperConnectorTone = (
  connectorIndex: number,
  currentStep: number,
): StepperConnectorTone => {
  if (connectorIndex < currentStep) {
    return 'completed'
  }

  if (connectorIndex === currentStep) {
    return 'active'
  }

  return 'inactive'
}
